"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterIcon = void 0;
const core_1 = require("@material-ui/core");
const React = require("react");
exports.ClusterIcon = () => {
    return React.createElement(core_1.SvgIcon, { style: { fontSize: 48 }, viewBox: "0 0 48 48" },
        React.createElement("svg", { width: "48", height: "48", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "6", cy: "6", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "10", cy: "6", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "14", cy: "14", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "7", cy: "10", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "12", cy: "6", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "17", cy: "14", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "10", cy: "17", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "11", cy: "9", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "14", cy: "17", r: "2", fill: "#C2CFE0" }),
            React.createElement("circle", { cx: "18", cy: "18", r: "2", fill: "#C2CFE0" })));
};
